const isExternalLink = (link: string | undefined, internalLink = false) => {
  return (
    link &&
    typeof link === "string" &&
    (link.startsWith("http") ||
      link.startsWith("www") ||
      /^(mailto|tel|sms):/i.test(link)) &&
    !internalLink
  )
}

export default isExternalLink
